import {mapGetters, mapMutations} from "vuex";

export default {
    name: 'graduate-work-header',
    data() {
        return {
            errorClass: false
        }
    },
    computed: {
        ...mapGetters({
            header: 'coursesGraduateWork/header',
        }),
    },
    methods: {
        ...mapMutations({
            changeHeader: 'coursesGraduateWork/CHANGE_HEADER',
        }),
        closeTest() {
            try {
                this.$router.push({name: 'course-dashboard'})
            } catch (e) {
                console.log(e);
            }
            this.changeHeader({
                show: false,
                parentRoute: ''
            });
        },
        closeHomeWork() {
            this.$router.push({name: 'courses-main', params: {item: this.$route.params.item}})
            this.changeHeader({show: false});
        }
    },
    destroyed() {
        this.changeHeader({
            show: false
        });
    }
}
